import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DocumentoComprovacaoService } from 'src/app/modules/services/documento-comprovacao/documento-comprovacao.service';
import { AfericaoServicoInicialService } from '../../afericao-servico-Inicial/afericao-servico-inicial.service';

@Component({
  selector: 'app-atendido-analise',
  templateUrl: './atendido-analise.component.html',
  styleUrls: ['./atendido-analise.component.scss']
})
export class AtendidoAnaliseComponent {
 comentarios = ``;
  idAfericao:any;
  transicaoNome:any;
  statusAtual:any;
constructor(

    private dialogRef: MatDialogRef<AtendidoAnaliseComponent>,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    private documentoComprovacaoService: DocumentoComprovacaoService,
    @Inject(MAT_DIALOG_DATA) public data: { 
      idAnaliseAfericao?: string, 
      statusAtualId?: string, 
      transicaoId?: string, 
      idEntidade?: string,
      transicaoNome?: string,
      statusAtual?: string,
      cnpj?: string,
    },
    public dialog: MatDialog,
  ) {
    this.statusAtual = this.data.statusAtual;
    this.transicaoNome = this.data.transicaoNome;

   }

  save(): void {

    const transicaoStatusRequestData = {
      idExterno: this.data.idAnaliseAfericao,
      idStatusAtual: this.data.statusAtualId,
      idTransicao: this.data.transicaoId,
      confirmacaoAtendimento: {
        comentario: this.comentarios
      }
    };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(transicaoStatusRequestData)], { type: 'application/json' }));
  
    this.dialogRef.close(formData);
  }


   cancel(): void {
    this.dialogRef.close(null);
  }
}
